import {Button, styled} from "@mui/material";

type TButtonProps = {
    active: boolean
}
export const SupportButton = styled(
    Button, {
    shouldForwardProp: (propName: PropertyKey) => (!['active'].includes(propName.toString()))
})<TButtonProps>(({ active, ...props }) => ({
    textDecoration: active ? 'none' : 'underline',
    color: '#FFFFFF',
    minWidth: 'unset',
    width: 'fit-content',
    padding: '1rem',
    '&:hover': {
        backgroundColor: 'unset',
    }
}))

SupportButton.defaultProps = {
    variant: "text",
}